import { Observable, ObservableArray } from 'knockout';
import WCCEntity from './entity';
import TranscriptJob, { JSONTranscriptJob } from './transcriptJob';
import TranscriptWord, { JSONTranscriptWord } from './transcriptWord';

export interface JSONTranscript {
    job: JSONTranscriptJob,
    words: Array<JSONTranscriptWord>
    words_text: string
}

export default class Transcript extends WCCEntity<JSONTranscript> {
    job: Observable<TranscriptJob>
    words: ObservableArray<TranscriptWord>
    text: Observable<string>

    constructor(data: JSONTranscript) {
        super();

        this.job = this.createMappedField(data, 'job', jsonJob => new TranscriptJob(jsonJob));
        this.words = this.createCollection(data, 'words', jsonWord => new TranscriptWord(jsonWord));
        this.text = this.createField(data, 'words_text');
    }
}